import { render, staticRenderFns } from "./package-card.vue?vue&type=template&id=7bb037c5&scoped=true&"
import script from "./package-card.vue?vue&type=script&lang=js&"
export * from "./package-card.vue?vue&type=script&lang=js&"
import style0 from "./package-card.vue?vue&type=style&index=0&id=7bb037c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb037c5",
  null
  
)

export default component.exports